import React from 'react'
import cx from 'classnames'

import RGlow from '../../components/Svg/radial-glow-3'
import Icon from '../../components/Svg/icon-th'
import Languages from '../../const/languages'

export default ({onClick, onMouseEnter, ...props}) => (
  <span className={cx("btn btn-nav-simple", props.className)} onClick={onClick} onMouseEnter={onMouseEnter}>
  	<div className="btn__icon"><Icon /></div>
  	<div className="btn__label btn__label__bottom">{Languages.menu}</div>
  	<div className="btn__circles"/>
	<div className="btn__glow">
		<RGlow />
	</div>
  </span>
)
